import { render } from "./readPage.vue?vue&type=template&id=ddea9f9a&scoped=true"
import script from "./readPage.vue?vue&type=script&lang=js"
export * from "./readPage.vue?vue&type=script&lang=js"

import "./readPage.vue?vue&type=style&index=0&id=ddea9f9a&lang=css"
import "./readPage.vue?vue&type=style&index=1&id=ddea9f9a&lang=scss"
import "./readPage.vue?vue&type=style&index=2&id=ddea9f9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddea9f9a"]])

export default __exports__